export function initPagination(containerSelector, itemSelector = '.paginated-item') {
    const list = document.querySelector(containerSelector);
    if (!list) return;

    const pageSize = parseInt(list.getAttribute('data-page-size'));
    const totalPages = parseInt(list.getAttribute('data-total-pages'));
    const items = list.querySelectorAll(itemSelector);

    if (!items.length || !pageSize || !totalPages) return;

    const pagination = list.parentElement.querySelector('.pagination');
    if (!pagination) return;

    const pageBtns = pagination.querySelectorAll('.page-btn');
    const prevBtn = pagination.querySelector('#prev-page');
    const nextBtn = pagination.querySelector('#next-page');

    let currentPage = 1;

    function showPage(page) {
        currentPage = page;

        const start = (page - 1) * pageSize;
        const end = start + pageSize;

        items.forEach((item, idx) => {
            item.style.display = (idx >= start && idx < end) ? 'block' : 'none';
        });

        pageBtns.forEach((btn, idx) => {
            btn.classList.toggle('--active', idx + 1 === page);
        });

        if (prevBtn) {
            prevBtn.disabled = page === 1;
            prevBtn.classList.toggle('--disabled', page === 1);
        }

        if (nextBtn) {
            nextBtn.disabled = page === totalPages;
            nextBtn.classList.toggle('--disabled', page === totalPages);
        }
    }

    pageBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const page = parseInt(btn.getAttribute('data-page'));
            showPage(page);
        });
    });

    if (prevBtn) {
        prevBtn.addEventListener('click', () => {
            if (currentPage > 1) showPage(currentPage - 1);
        });
    }

    if (nextBtn) {
        nextBtn.addEventListener('click', () => {
            if (currentPage < totalPages) showPage(currentPage + 1);
        });
    }

    showPage(1);
}